// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1maFE","newExpiryDate":"styles_newExpiryDate__38XFV","footer":"styles_footer__2HHh2"};